import React, { useState } from "react";
import axios from "axios";


const useNewsWeightType = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const [newsWeightTypeOption, setNewsWeightTypeOption] = useState([])
    const getNewsWeightTypeOption = (params) => {
        axios.get('/system/news/weight_type', {
            params:{
                // current: 1,
                // pageSize: 20,
                // size: 20,
                // cur_page: 1,
            }
        })
            .then((response) => {
                let data = response.data?.data
                data = data.map((value)=>{
                    return {
                        label :value?.news_weight_type_name,
                        value :value?.news_weight_type_id,
                        ...value
                    }
                })
                setNewsWeightTypeOption(data)
            });
    }
    const getNewsWeightTypeData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/system/news/weight_type', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postNewsWeightTypeData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/system/news/weight_type',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchNewsWeightTypeData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/system/news/weight_type',
                data
            
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteNewsWeightTypeData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete('/system/news/weight_type',
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
   
    return {
        newsWeightTypeOption:newsWeightTypeOption,
        newsWeightTypeData: data,
        getNewsWeightTypeOption,
        getNewsWeightTypeData,
        postNewsWeightTypeData,
        patchNewsWeightTypeData,
        deleteNewsWeightTypeData,
    }
}
export { useNewsWeightType }
